<template>
  <div class="container">
    <Header :theme="theme"></Header>
    <div class="fullPage" ref="fullPage">
      <div
        class="fullPageContainer"
        ref="fullPageContainer"
        @mousewheel="mouseWheelHandle" 
        @DOMMouseScroll="mouseWheelHandle"
      >
        <div :class="`section introduction ${fullpage.current===1?'in':'out'}`" :style="`background-image: url(${introductionBack})`">
          <div class="content">
            <div class="text">
              <h1 class="name">南京浩伟智能科技有限公司</h1>
              <h2 class="intro">是一家专业从事计算机信息技术研发、生产、销售和服务的高科技企业</h2>
            </div>
            <el-button class="btn" type="primary" @click="contactUs">立即联系</el-button>
          </div>
        </div>
        <div :class="`section philosophy ${fullpage.current===2?'in':'out'}`" :style="`background-image: url(${philosophyBack})`">
          <el-image class="right-back-img" :src="philosophyBuilding"></el-image>
          <div class="content">
            <div class="text">
              <p class="en">CORPORATE PHILOSOPHY</p>
              <div class="divider"></div>
              <p class="title">企业理念</p>
              <p class="intro">质量树品质，诚信立伟业</p>
            </div>
          </div>
        </div>
        <div :class="`section strength ${fullpage.current===3?'in':'out'}`" :style="`background-image: url(${strengthBack})`">
          <div class="content">
            <div class="text">
              <p class="en">OUR STRENGTHS</p>
              <div class="divider"></div>
              <p class="title">我们的优势</p>
              <div class="strength-list">
                <div class="item" v-for="(item,index) in strengths" :key="index">
                  <el-image class="icon" :src="item.icon"></el-image>
                  <p class="name">{{item.name}}</p>
                  <p class="des">{{item.intro}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="`section service ${fullpage.current===4?'in':'out'}`" :style="`background-image: url(${serviceBack})`">
          <div class="content">
            <div class="text">
              <p class="en">OUR SERVICES</p>
              <div class="divider"></div>
              <p class="title">我们的服务</p>
              <p class="des">
                真诚 专业 周到；<br/>
                最快的速度，最专业的技术；<br/>
                免费上门培训、安装、调试、维修；<br/>
                定期或不定期的产品使用质量跟踪、回访； <br/>
                公司产品均有唯一编号，对所设备均有详细记载，定期或不定期进行产品使用跟踪、回访，以便及时解决问题。
              </p>
            </div>
            <div class="footer">
              <a href='javascript:void(0)' onclick="window.location.href= 'https://beian.miit.gov.cn/#/Integrated/index'">
                网站备案号：苏ICP备17031961号
              </a>
              Copyright © 2019 - 2025  All Rights Reserved. 南京浩伟智能科技有限公司 版权所有
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header"
export default {
  components:{
    Header,
  },
  data(){
    return{
      introductionBack:require("@/assets/img/index/introduction.png"),
      philosophyBack:require("@/assets/img/index/philosophy.png"),
      philosophyBuilding:require("@/assets/img/index/philosophy-building.png"),
      strengthBack:require("@/assets/img/index/strength.png"),
      serviceBack:require("@/assets/img/index/service.png"),
      theme:"white",
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      strengths:[
        {
          icon:require("@/assets/img/index/strength1.png"),
          name:'贴近实战',
          intro:'支撑多政法专业教学\n积累各警种实训脚本',
        },
        {
          icon:require("@/assets/img/index/strength2.png"),
          name:'执法场景多态化',
          intro:'各类警情\n自定义场景',
        },
        {
          icon:require("@/assets/img/index/strength3.png"),
          name:'协同作战',
          intro:'并发训练考核\n训考数据分析',
        },
        {
          icon:require("@/assets/img/index/strength4.png"),
          name:'项目经验丰富',
          intro:'专注政法教学实训\n教学训练考核体系',
        },
      ],
    }
  },
  methods:{

    contactUs(){
      this.$router.push({
				name:'contact-us'
			})
    },

    next() { // 往下切换
      let len = 4; // 页面的个数
      if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
      this.fullpage.current += 1; // 页面+1
      this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {// 往上切换
      if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
      this.fullpage.current -= 1;// 页面+1
      this.move(this.fullpage.current);// 执行切换
      }
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      if(index===3 || index===4){
        this.theme="black"
      }else{
        this.theme="white"
      }
      setTimeout(() => {  //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
      this.fullpage.isScrolling = false;
      }, 1010);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      scrollHeight= -(index - 1) * height + "px";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheelHandle(event) { // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
      evt.stopPropagation();
      } else {
      evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) { // 判断是否可以滚动
      return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
      this.next();
      } else if (this.fullpage.deltaY < 0) {
      this.pre();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  width: 100%;
  animation-timing-function: ease;

  .fullPage{
    height: 100vh;
    overflow: hidden;

    .fullPageContainer{
      width: 100%;
      height: 100vh;
      transition: all linear 1s;

      .section{
        width: 100%;
        height: 100vh;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-size: cover;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .content{
          width: 100rem;
          margin: 0 auto;
          color: #fff;
          height: 57.5rem;
          font-size: 1.125rem;
          font-weight: 400;
          line-height: 1.3125rem;

          .text{

            .en{
              font-size: 1.875rem;
              line-height: 3.75rem;
              font-weight:bold;
              opacity: 0.5;
            }
            .divider{
              width: 3.75rem;
              height: .25rem;
              background-color: #fff;
            }
            .title{
              font-size: 2rem;
              line-height: 2.5rem;
              font-weight: bold;
              margin-top: 1.25rem;
            }
            .intro{
              margin-top: 8.75rem;
              font-size: 4rem;
              line-height: 4.375rem;
              font-weight: bold;
              letter-spacing: .1875rem;
            }
          }
        }
      }
      .introduction{

        .content{

          .text{
            margin-top: 18.75rem;

            .name{
              font-size: 4.5rem;
              line-height: 5.375rem;
              letter-spacing: .125rem;
              font-weight:bold;
            }
            .intro{
              font-size: 1.875rem;
              line-height: 2.5rem;
              font-weight: 400;
              margin-top: 1.25rem;
            }
          }

          .btn{
            margin-top: 6.25rem;
            width: 9.375rem;
            height: 3.125rem;
            background-color: #fff;
            border-radius: .9375rem 0 .9375rem 0;
            color: #409EFF;
            text-align: center;
            font-size: 1.25rem;
            line-height: 1.875rem;
            letter-spacing: .0625rem;
            padding: 0 .625rem;
            font-weight: bold;
          }
        }
      }
      .philosophy{
        position: relative;
        .right-back-img{
          position: absolute;
          width: 100%;
          height: 100vh;
          z-index: 2;
        }

        .content{
          z-index: 3;

          .text{
            margin-top: 12.5rem;

          }
        }
      }
      .strength{

        .content{

          .text{
            color: #303133;
            margin-top: 12.5rem;

            .divider{
              background-color: #303133;
            }
            .strength-list{
              width: 62.5rem;
              margin-top: 5rem;
              display: flex;
              justify-content: space-between;

              .item{
                font-weight: 400;
                line-height: 2.1875rem;
                color: #373737;
                text-align: center;

                .icon{
                  width: 6.875rem;
                  height: 6.875rem;
                }
                .name{
                  color: #409EFF;
                  font-weight: bold;
                  margin-top: 1.25rem;
                  font-size: 1.5rem;
                }
                .des{
                  word-wrap: break-word;
                  white-space: pre-wrap;
                  margin-top: .625rem;
                  font-size: 1rem;
                  line-height: 1.5rem;
                }
              }
            }
          }
        }
      }
      .service{
        .content{
          position: relative;

          .text{
            color: #303133;
            margin-top: 12.5rem;

            .divider{
              background-color: #303133;
            }
            .des{
              margin-top: 5.625rem;
              font-size: 1.375rem;
              line-height: 2.5rem;
              color: #303133;
              letter-spacing: .125rem;
            }
          }
          .footer{
            position: absolute;
            line-height: 5rem;
            left: 0;
            bottom: 0;
            color: #303133;

            a{
              color: #303133;
              text-decoration: none;
              margin-right: 2rem;
            }
          }
        }
      }
      .in{
        .text{
          animation: transTextIn 1s ease-out;
        }
        .btn{
          animation: btnShow 1s ease-out;
        }
        .right-back-img{
          animation: backIn 1s ease-out;
        }
      }
      .out{
        .text{
          animation: transTextOut 1s ease-out;
        }
        .btn{
          animation: btnHidden 1s ease-out;
        }
        .right-back-img{
          animation: backOut 1s ease-out;
        }
      }
      @keyframes transTextIn {
        from {
          transform: translate(-75rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes transTextOut {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(-75rem, 0);
        }
      }
      @keyframes btnShow {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      @keyframes btnHidden {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }
      @keyframes backIn {
        from {
          transform: translate(57.5rem, 0);
        }
        to {
          transform: translate(0, 0);
        }
      }
      @keyframes backOut {
        from {
          transform: translate(0, 0);
        }
        to {
          transform: translate(57.5rem, 0);
        }
      }
    }

  }
}
</style>